// api.js

import axiosInstance from "../utils/axios-instance";

export const clientConfigService = {
  fetch: async (client_id, key) => {
    try {
      const response = await axiosInstance.post(`/client-config`, {
        client_id,
        key,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCount: async (client_id, service) => {
    try {
      const response = await axiosInstance.post(`/core-collection-count`, {
        client_id,
        service,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
